import React, {useRef} from 'react';
import {Link} from 'react-router-dom';

import Card from '../kartice/card.components';

import './glavnenajave.styles.css';


const GlavneNajave = props => {
    
    return(
    <section className="section-tours" id="section-tours">
                <div className="u-center-text u-margin-bottom-big">
                    <h2 className="heading-secondary">
                        Naše Akcije
                    </h2>
                </div>

                <div className="row">
                {props.najave && props.najave.map(najava => ( 
                    <Card 
                        key={najava.id}
                        id={najava.id}
                        naslov={ najava.naslov }
                        plan={najava.plan}
                        datum={najava.datum} 
                        visina={najava.visina}
                        duzina={najava.duzina}
                        tezina={najava.tezina}
                        cena={najava.cena}
                        kategorija={najava.kategorija}
                        image={`${process.env.REACT_APP_ASSET_URL}/${najava.image}`} 
                    /> ))}
                 
             
                </div>

                <div className="u-center-text u-margin-top-huge">
                    <Link to="/najave"  className="btn btn--green" > Sve Najave </Link>
                   
                </div>
            </section>
);
                    }


export default GlavneNajave;